<template>
	<div>
		<router-view/>
		<blumar-loading/>
		<blumar-alert/>
	</div>
</template>

<script>
import Home from './components/home/Home';
import BlumarLoading from "./components/shared/BlumarLoading.vue";
import BlumarAlert from "./components/shared/BlumarAlert.vue";
import executeInterceptor from './services/HttpHelper';
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
	components: { Home, BlumarLoading, BlumarAlert },
	created() {
		executeInterceptor();
	}
};
</script>

<style lang="scss">
@import './bootstrap-theming.scss';

body {
	background: #163247;
}

.pages-enter,
.pages-leave-active {
	opacity: 0;
}
.pages-enter-active,
.pages-leave-active {
	transition: opacity 0;
}
.container > .module-welcome {
	margin-top: 20%;
	text-align: center;
}
table.table-list {
	margin-top: 5%;
}
thead.list th {
	border-top: 0 !important;
	background-color: transparent !important;
}
.form-group > label {
	font-weight: bold;
}
h3 {
	font-size: 1.5rem;
	font-weight: 400;
}
.actions i {
	cursor: pointer;
	color: #000;
}
.actions i:hover {
	font-weight: bold;
}
a:link,
a:visited {
	text-decoration: none !important;
}

// body {
//   margin: 0;
//   font-family: 'Lucida Sans Unicode', 'Arial', 'Helvetica', 'sans-serif';
//   color: #253b6d;
// }
// ul {
//   list-style-type: none;
//   margin: 0;
//   padding: 0;
// }
// a {
//   text-decoration: none;
//   color: inherit;
// }
// a:hover {
//   color: #42bc97;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue